import getStore from '../store';

export function getHasUserRetried() {
    return getStore().hasUserRetried;
}
